import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CancelRequestBody, CancelResponse, DetailCampaignResponse, EmailCampaignResponse } from './email-history.model';
import { catchError, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class EmailHistoryService {

  constructor(
    private readonly http: HttpClient,
    private readonly toast: ToastrService,
  ) { }

  getCampaignHistory(params?: any): Observable<EmailCampaignResponse> {
    return this.http.get<EmailCampaignResponse>(`${environment.url}/email-marketing/campaigns`, {params}).pipe(
      catchError(() => {
        return EMPTY;
      }),
    );
  }

  cancelRequest(body: CancelRequestBody): Observable<CancelResponse> {
    return this.http.post<CancelResponse>(`${environment.url}/email-marketing/campaign/cancel`, body).pipe(
      tap({
        next: (r) => {
          if (r.status === 1000) {
            this.toast.success('Campaign cancelled successfully');
            return;
          }
          this.toast.error(r.message);
        },
      }),
      catchError((err: HttpErrorResponse) => {
        this.toast.error(err.error?.message);
        return EMPTY;
      }),
    );
  }

  getDetail(id: string, params = {}): Observable<DetailCampaignResponse>{
    return this.http.get<DetailCampaignResponse>(`${environment.url}/email-marketing/campaign/${id}`, {params});
  }

}
